export function someGetter(/* state */) {}

export function getFilters(state) {
  const { degrees, projects, curriculums } = state;

  const filters = {
    "filter-sort": ["degrees", "projects", "curriculums"],
    "filter-set": {
      degrees: {
        id: "degrees",
        title: "Degrees",
        keys: ["code", "nameLocal"],
        options: [...degrees]
      },
      projects: {
        id: "projects",
        title: "Projects",
        keys: ["id", "nameLocal"],
        options: [...projects]
      },
      curriculums: {
        id: "curriculums",
        title: "Curriculums",
        keys: ["code", "nameLocal"],
        options: [...curriculums]
      }
    }
  };
  return filters;
}

export function getFiltersCurriculum(state) {
  const { curriculums } = state;

  const filters = {
    "filter-sort": ["curriculums"],
    "filter-set": {
      curriculums: {
        id: "curriculums",
        title: "Curriculums",
        keys: ["code", "nameLocal"],
        options: [...curriculums]
      }
    }
  };
  return filters;
}
